import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  View,
  TouchableOpacity,
} from 'react-native';
import { CrossIcon, SuccessIcon } from '../../../components/common/icons';
import Text from '@dbk/ui-text';
import styles from './dismissable-bar-success.styles';
import { PALETTE } from '../../../constants';

class DismissableBar extends PureComponent {

  dismiss = (error, key) => this.props.closeDismissableBar(error, key);

  render() {
    const {
      error: { 
        errorDesc , 
      },
      error,
      keyValue,
    } = this.props;

    return (
      <View style={ styles.rootSuccess}>
        <View style={styles.iconType}>
          <SuccessIcon width={30} height={30} color={PALETTE.turquoiseGreen} />
        </View>
        <View accessible={true} style={styles.typeMessage}>
          <Text>{errorDesc}</Text>
        </View>
        <View style={styles.closeMark}>
          <TouchableOpacity style={styles.closeContainer} onPress={(e) => this.dismiss(error, keyValue)}>
            <CrossIcon color={ PALETTE.secondaryText } height={30} width={30} />
          </TouchableOpacity>
        </View>
      </View>
    );
  }
}

DismissableBar.propTypes = {
  errorType: PropTypes.string,
};

DismissableBar.defaultProps = {
  errorType: "Error"
};

export default DismissableBar;
